// SystemDeviceHardware Action Types
// The REAL SystemDevice entity (physical POS hardware: POS terminals, printers,
// payment/card readers) backed by /systemdevice/*. Kept separate from the older
// `SystemDevice` store slice, which actually drives PosSystem (store) management.

///systemdevice/list
export const SDHW_GET_LIST = "SDHW_GET_LIST";
export const SDHW_GET_LIST_SUCCESS = "SDHW_GET_LIST_SUCCESS";
export const SDHW_GET_LIST_FAILURE = "SDHW_GET_LIST_FAILURE";

///systemdevice/data/{id}
export const SDHW_GET_DATA = "SDHW_GET_DATA";
export const SDHW_GET_DATA_SUCCESS = "SDHW_GET_DATA_SUCCESS";
export const SDHW_GET_DATA_FAILURE = "SDHW_GET_DATA_FAILURE";

///systemdevice/readerstatus/{id}
export const SDHW_GET_READER_STATUS = "SDHW_GET_READER_STATUS";
export const SDHW_GET_READER_STATUS_SUCCESS = "SDHW_GET_READER_STATUS_SUCCESS";
export const SDHW_GET_READER_STATUS_FAILURE = "SDHW_GET_READER_STATUS_FAILURE";

///systemdevice/testreader/{id}
export const SDHW_TEST_READER = "SDHW_TEST_READER";
export const SDHW_TEST_READER_SUCCESS = "SDHW_TEST_READER_SUCCESS";
export const SDHW_TEST_READER_FAILURE = "SDHW_TEST_READER_FAILURE";
